module.exports = __webpack_public_path__ + "img/android-wallpaper-beach-dawn-189349@2x.c7fcc128.png";